import React, {useState, useLayoutEffect} from 'react';
import {WordList} from './containers/WordList';
import {StudyMode} from './containers/StudyMode';
import {ChatPractice} from './containers/ChatPractice';
import {ProgressPage} from './containers/ProgressPage';
import {HebrewVerbsLibrary} from './containers/HebrewVerbsLibrary';
import {HebrewVerbDrill} from './containers/HebrewVerbDrill';
import {AdminPage} from './containers/AdminPage';
import {Topbar} from './containers/Topbar';
import {MobileBottomNav} from './components/MobileBottomNav';
import {LoginPage} from './components/LoginPage';
import {OAuthCallback} from './components/OAuthCallback';
import {Router, Redirect, Route, Switch} from 'react-router-dom';
import {history} from './helpers/history';
import {AI_FEATURES_ENABLED} from './helpers/featureFlags';
import {AiAvailabilityProvider} from './contexts/AiAvailability';
import {AuthProvider, useAuth} from './contexts/Auth';

const ProtectedRoute = ({component: Component, ...rest}) => {
  const {isAuthenticated} = useAuth();
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

const AppRoutes = ({location}) => {
  const {isAuthenticated} = useAuth();
  return (
    <>
      {isAuthenticated && <Topbar location={location} />}
      <Switch>
        <Route exact path="/login" component={LoginPage} />
        <Route exact path="/auth/callback" component={OAuthCallback} />
        <ProtectedRoute exact path="/" component={WordList} />
        <ProtectedRoute exact path="/study" component={StudyMode} />
        <ProtectedRoute exact path="/progress" component={ProgressPage} />
        <ProtectedRoute exact path="/admin" component={AdminPage} />
        <ProtectedRoute exact path="/verbs" component={HebrewVerbsLibrary} />
        <ProtectedRoute exact path="/verb-drill" component={HebrewVerbDrill} />
        {AI_FEATURES_ENABLED ? (
          <ProtectedRoute exact path="/practice" component={ChatPractice} />
        ) : (
          <Redirect from="/practice" to="/" />
        )}
        <Redirect to="/" />
      </Switch>
      {isAuthenticated && <MobileBottomNav location={location} />}
    </>
  );
};

export const App = () => {
  const [location, setLocation] = useState(history.location);

  useLayoutEffect(() => {
    const unlisten = history.listen((loc) => setLocation(loc));
    return unlisten;
  }, []);

  return (
    <AuthProvider>
      <AiAvailabilityProvider>
        <Router history={history}>
          <AppRoutes location={location} />
        </Router>
      </AiAvailabilityProvider>
    </AuthProvider>
  );
};

